import moment from "moment";
import { IndicesDto } from "api/dtos/IndicesDto";
import axiosInstance from "api/utils/axiosInstance";
import { constructURL, URLS } from "api/utils/baseUrls";
import { blobToBase64Url, fetchBlob } from "api/utils/fetchBlob";
import { DATE_FORMAT } from "constants/dateFormat";
import { constructSearchParams } from "utils/constructSearchParams";
import { IndicesStatisticsDto } from "api/dtos/IdnicesDataDto";

const DefaultParams = {
  cloud: 30,
  collections: "l2a-collection",
  resampling: "nearest",
  pixelSelection: "median",
  reproject: "nearest",
  height: 256,
  width: 256,
};

const getIndexTypes = async () => {
  const url = constructURL(URLS.satellite, "stac/available-indexes");
  try {
    const { data, ...restRes } = await axiosInstance.get(url);
    const newData = IndicesDto.fromApiArrayTypes(data);
    return { ...restRes, data: newData };
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const getIndices = async ({ fieldId, startDate, endDate }) => {
  const url = constructURL(URLS.satellite, "stac/search-items");
  const params = constructSearchParams({
    startDate,
    endDate,
    collections: "l2a-collection",
    fieldId,
  });

  try {
    const { data } = await axiosInstance.get(url, {
      params,
    });
    const indices = IndicesDto.fromApiArray(data, { startDate, endDate });
    return indices;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const getIndexImage = async ({ fieldId, date, index }) => {
  const url = constructURL(URLS.satellite, "titiler/index");

  const params = constructSearchParams({
    fieldId,
    index,
    startDate: moment(date).format(DATE_FORMAT),
    endDate: moment(date).add(1, "days").format(DATE_FORMAT),
    maskClouds: true,
    reproject: "cubic",
    dstCrs: "epsg:4326",
    unscale: true,
    collections: "l2a-collection",
  });

  const paramsString = params.toString();

  try {
    const blob = await fetchBlob(`${url}?${paramsString}`);
    const image = blobToBase64Url(blob);
    return image;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const getIndexStatistics = async ({
  fieldId,
  startDate,
  endDate,
  indices = [],
}) => {
  const url = constructURL(URLS.statisticsV2, "satellite-statistics");
  try {
    const params = constructSearchParams({
      fieldId,
      startDate,
      endDate,
      indexes: indices,
    });

    const res = await axiosInstance.get(url, { params });
    const data = IndicesStatisticsDto.fromApi(res.data, startDate, endDate);

    return data;
  } catch (error) {
    console.error("Error fetching the satellite statistics:", error);
    throw error;
  }
};

export const satelliteApi = {
  fetchMany: getIndices,
  fetchImage: getIndexImage,
  fetchTypes: getIndexTypes,
  fetchStatistics: getIndexStatistics,
};
